import { useEffect, useRef, useState } from "react";

import aboutPoster from "@/assets/images/user/aboutPoster.jpg";
import programArt from "@/assets/images/user/programArt.svg";
import programFesta from "@/assets/images/user/programFesta.svg";
import programFocus from "@/assets/images/user/programFocus.svg";
import programPlay from "@/assets/images/user/programPlay.svg";
import programStage from "@/assets/images/user/programStage.svg";
import ProgramAccordion from "@/components/user/common/ProgramAccordion";
import SubTitle from "@/components/user/common/SubTitle";
import TitleBox from "@/components/user/common/TitleBox";

const programList = [
    {
        title: "무대 프로그램",
        background: "bg-program202501",
        img: programStage,
        contents: (
            <ul className="flex flex-col gap-[16px] p-[8px] md:p-[22px_6px] md:gap-[24px] xl:p-[22px]">
                <li className="flex flex-col gap-[8px]">
                    <p className="text-[16px] font-['GongGothicBold'] text-[#FF5B2E] md:text-[24px]">MAIN STAGE DAY1</p>
                    <p className="md:text-[24px]">
                        사전 공연 <br className="md:hidden" />
                        <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>
                        GXG 2025 개막식&축하 공연 <br className="md:hidden" />
                        <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>
                        The 2nd GXG SOUND TRACK
                    </p>
                </li>
                <li className="flex flex-col gap-[8px]">
                    <p className="text-[16px] font-['GongGothicBold'] text-[#FF5B2E] md:text-[24px]">MAIN STAGE DAY2</p>
                    <p className="md:text-[24px]">
                        일러스타 페스 STAGE <br className="md:hidden" />
                        <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>
                        GXG 플레이 타임 <br className="md:hidden" />
                        <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>
                        GXG 갈라 콘서트
                    </p>
                </li>
                <li className="flex flex-col gap-[8px]">
                    <p className="text-[16px] font-['GongGothicBold'] text-[#FF5B2E] md:text-[24px]">
                        SUB STAGE DAY1 & DAY2
                    </p>
                    <p className="md:text-[24px]">GXG 버스킹 타임</p>
                </li>
            </ul>
        ),
    },
    {
        title: "체험 프로그램",
        background: "bg-program202502",
        img: programPlay,
        contents: (
            <p className="p-[8px] md:p-[22px_6px] md:text-[24px] xl:p-[22px]">
                브랜드 체험존
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>GXG 마켓
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>GXG 플레이 라운지
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>
                Cool Station with 동아오츠카
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>GXG 캠퍼스 아케이드
            </p>
        ),
    },
    {
        title: "전시 프로그램",
        background: "bg-program202503",
        img: programArt,
        contents: (
            <p className="p-[8px] md:p-[22px_6px] md:text-[24px] xl:p-[22px]">
                GXG 씨어터
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>GXG 아트북 라운지
            </p>
        ),
    },
    {
        title: "GXG 컨퍼런스",
        background: "bg-program202504",
        img: programFocus,
        contents: (
            <>
                <p className="p-[8px] md:p-[22px_6px] md:text-[24px] xl:p-[22px]">
                    GXG 2025 컨퍼런스 NEXT PLAY <br className="md:hidden" />
                    with Microsoft Cloud & AI
                </p>
                <a
                    href="https://2025gxgconference.co.kr/"
                    target="_blank"
                    rel="noreferrer"
                    className="m-[20px_auto_0] relative block w-full h-[72px] text-white text-[20px] text-center leading-[70px] font-['GongGothicMedium'] clip-path-octagon border border-black bg-black max-w-[320px]"
                >
                    <span>GXG 2025 컨퍼런스 신청하기</span>
                    <span className="absolute left-0 top-0 border-[8px] border-black border-b-transparent border-r-transparent" />
                    <span className="absolute left-0 bottom-0 border-[8px] border-black border-t-transparent border-r-transparent" />
                    <span className="absolute right-0 top-0 border-[8px] border-black border-b-transparent border-l-transparent" />
                    <span className="absolute right-0 bottom-0 border-[8px] border-black border-t-transparent border-l-transparent" />
                </a>
            </>
        ),
    },
    {
        title: "GXG 콜라보레이션",
        background: "bg-program202505",
        img: programFesta,
        contents: (
            <p className="p-[8px] md:p-[22px_6px] md:text-[24px] xl:p-[22px]">
                인디크래프트
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>일러스타 페스
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>성남청년 플리마켓
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>
                <br className="md:hidden" />
                GV2025
            </p>
        ),
    },
];

export default function About() {
    const sect2Ref = useRef<HTMLDivElement>(null);
    const [sect2On, setSect2On] = useState(false);

    //스크롤시 section on
    const scrollSectOn = () => {
        const scroll = window.scrollY;
        const sections: {
            ref: React.RefObject<HTMLDivElement>;
            onSet: React.Dispatch<React.SetStateAction<boolean>>;
        }[] = [{ ref: sect2Ref, onSet: setSect2On }];

        sections.forEach(({ ref, onSet }) => {
            if (ref.current) {
                const offsetTop = ref.current.offsetTop;
                if (scroll >= offsetTop - 100) {
                    onSet(true);
                }
            }
        });
    };

    useEffect(() => {
        window.addEventListener("scroll", scrollSectOn);

        return () => {
            window.removeEventListener("scroll", scrollSectOn);
        };
    }, []);

    return (
        <div className="px-[20px] xl:px-0">
            <section>
                <div className="max-w-[1400px] w-full mx-auto font-['GongGothicMedium'] flex flex-col gap-[30px] text-[18px] text-center [&>p>span]:text-primary p-[20px_0_40px] md:p-[80px_0_120px] md:gap-[60px] md:text-[28px]">
                    <p className="text-[28px] md:text-[48px]">
                        Welcome to <span>GXG</span>
                    </p>
                    <p>
                        전 세대가 모두 함께 <br className="md:hidden" />
                        게임 문화를 즐길 수 있는 공간!
                    </p>
                    <p>
                        GXG는 단순히 완성된 게임을 <br className="md:hidden" />
                        체험하는 것을 넘어, <br />
                        다양한 게임의 문화적 요소에 초점을 맞춘 <span>복합문화축제</span> 입니다.
                    </p>
                    <p>
                        음악, 영상, 아트, 스토리 등 <br className="md:hidden" />
                        게임이 가진 <br />
                        다채로운 요소들이 어우러져
                        <br />
                        가장 색다른 게임 축제로 기억에 남을 <br className="md:hidden" />
                        <span>GXG</span>에 여러분을 초대합니다!
                    </p>
                </div>
            </section>
            <section className="max-w-[1400px] w-full mx-auto pb-[120px] md:pb-[160px]" ref={sect2Ref}>
                <TitleBox title="ABOUT" text="GXG 2025" />
                <div className="pt-[40px] md:pt-[60px] xl:flex xl:gap-[48px]">
                    <div className={`opacity-0${sect2On ? " animate-slide-in-from-bottom-30" : ""}`}>
                        <img src={aboutPoster} alt="GXG 2025" />
                    </div>
                    <div
                        className={`pt-[40px] w-full opacity-0 md:pt-[60px] xl:pt-0 xl:flex-1${sect2On ? " animate-slide-in-from-right" : ""}`}
                    >
                        <ul className="flex flex-col gap-[12px] md:gap-[16px] xl:h-full xl:justify-between">
                            <li className="flex items-center gap-[12px] md:gap-[16px]">
                                <p className="max-w-[70px] w-full text-[18px] py-[8px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[28px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[140px] md:text-[22px] md:py-[18px]">
                                    {"행사명"}
                                </p>
                                <p className="text-[16px] font-medium text-black flex-1 font-['GongGothicLight'] leading-[1.5] md:text-[24px]">
                                    GXG 2025 <br className="md:hidden" />
                                    <span className="text-[14px] md:text-[22px]">(Game culture X Generation 2025)</span>
                                </p>
                            </li>
                            <li className="flex items-center gap-[12px] md:gap-[16px]">
                                <p className="max-w-[70px] w-full text-[18px] py-[8px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[28px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[140px] md:text-[22px] md:py-[18px]">
                                    {"일  정"}
                                </p>
                                <p className="text-[16px] font-medium text-black flex-1 font-['GongGothicLight'] leading-[1.8] md:text-[24px]">
                                    9월 19일(금) ~ 20일(토), 2일 간
                                </p>
                            </li>
                            <li className="flex items-center gap-[12px] md:gap-[16px]">
                                <p className="max-w-[70px] w-full text-[18px] py-[8px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[28px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[140px] md:text-[22px] md:py-[18px]">
                                    {"장  소"}
                                </p>
                                <p className="text-[16px] font-medium text-black flex-1 font-['GongGothicLight'] leading-[1.8] md:text-[24px]">
                                    경기도 성남시 판교역 일대
                                </p>
                            </li>
                            <li className="flex items-center gap-[12px] md:gap-[16px]">
                                <p className="max-w-[70px] w-full text-[18px] py-[8px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[28px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[140px] md:text-[22px] md:py-[18px]">
                                    {"주  최"}
                                </p>
                                <p className="text-[16px] font-medium text-black flex-1 font-['GongGothicLight'] leading-[1.8] md:text-[24px]">
                                    성남시
                                </p>
                            </li>
                            <li className="flex items-center gap-[12px] md:gap-[16px]">
                                <p className="max-w-[70px] w-full text-[18px] py-[8px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[28px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[140px] md:text-[22px] md:py-[18px]">
                                    {"주  관"}
                                </p>
                                <p className="text-[16px] font-medium text-black flex-1 font-['GongGothicLight'] leading-[1.8] md:text-[24px]">
                                    성남산업진흥원, 게임문화재단
                                </p>
                            </li>
                            <li className="flex items-start gap-[12px] md:gap-[16px]">
                                <p className="max-w-[70px] w-full text-[18px] py-[8px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[28px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[140px] md:text-[22px] md:py-[18px]">
                                    {"후  원"}
                                </p>
                                <p className="text-[15px] font-medium text-black flex-1 font-['GongGothicLight'] leading-[1.8] md:text-[24px]">
                                    문화체육관광부, 한국콘텐츠진흥원, <br className="md:hidden" />
                                    게임물관리위원회, <br className="hidden md:block" />
                                    경기도, 경기관광공사, <br className="md:hidden" />
                                    성남시청소년청년재단, 넥슨코리아, <br className="md:hidden" />
                                    엔씨소프트, 호요버스, 슈퍼셀, <br className="md:hidden" />
                                    펄어버스, 레드프린팅, 동아오츠카, 마이크로소프트, <br className="md:hidden" />
                                    클라우디드 레오파드 엔터테인먼트코리아
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
                <SubTitle title="프로그램" className="p-[40px_0_20px] md:p-[60px_0_40px]" />
                <ProgramAccordion list={programList} />
            </section>
        </div>
    );
}
